import axios from 'axios';
import { restClient, restClientGeneral } from 'libs/restClient';
import { clearSession } from 'libs/sessionStorage';
import { uri, apiUrl, generalApiUrl } from 'dictionaries/Env';
import { notifyMessages } from 'helpers/NotifyHelper';
import * as actions from 'actions/types';

export const loginCauseway = (
  ticket,
  callback,
  errCallback
) => async dispatch => {
  try {
    // WARNING: must use "clear" axios w/o token
    const url = `${apiUrl}/login?service=${uri}&ticket=${ticket}`;
    const response = await axios.get(url);

    dispatch({ type: actions.SAVE_USER_TOKEN, payload: response.data.data });
    dispatch({ type: actions.SET_ACCESS_ERROR_FLAG, payload: false });

    callback();
  } catch (e) {
    dispatch({ type: actions.SET_ACCESS_ERROR_FLAG, payload: false });
    errCallback();
  }
};

export const loginCTIA = (username, password, callback) => async dispatch => {
  try {
    // WARNING: must use clear axios w/o token
    const url = `${generalApiUrl}/admin/login`;
    const response = await axios({
      method: 'get',
      url,
      auth: {
        username,
        password
      }
    });

    dispatch({ type: actions.SAVE_USER_TOKEN, payload: response.data.data });
    dispatch({ type: actions.SET_ACCESS_ERROR_FLAG, payload: false });

    callback();
  } catch (e) {
    dispatch({ type: actions.SET_ACCESS_ERROR_FLAG, payload: true });
  }
};

export function logout(callback) {
  callback();

  return {
    type: actions.LOGOUT,
    payload: null
  };
}

export const refreshToken = callback => async dispatch => {
  try {
    const response = await restClientGeneral.get('/refresh');
    dispatch({ type: actions.SAVE_USER_TOKEN, payload: response.data.data });
    callback();
  } catch (e) {
    // clear client session
    clearSession();

    // show notice
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.authError
    });
  }
};

export function agreeTerms(agreed) {
  const url = `/agreed?answer=${agreed}`;
  const payload = restClient
    .put(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.AGREE_TERMS,
    payload
  };
}

export function toggleEditMode() {
  return {
    type: actions.TOGGLE_REQUEST_EDIT_MODE,
    payload: null
  };
}

export const signVendorAgreement = (
  callback,
  errCallback,
  answer = 1
) => async dispatch => {
  try {
    const url = `/agreements/vendorparticipation/agree?answer=${answer}`;
    const response = await restClient.put(url);

    dispatch({ type: actions.SAVE_USER_TOKEN, payload: response.data.data });
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.vendorAgreementSigned
    });

    // re-call backend for updated user data
    callback();
  } catch (e) {
    errCallback();
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.cantSignVendorAgreement
    });
  }
};

export const getUserInfo = () => async dispatch => {
  try {
    const response = await restClientGeneral.get('/me');
    dispatch({ type: actions.GET_USER_INFO, payload: response.data.data });
  } catch (e) {
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.authError
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/user.js